import { OringRecommendation } from '../../details/OringRecommendation';
import { OringRecommendationService } from '../../service/OringRecommendationService';
import { UnitSystem } from '../../details/UnitSystem';
import { OringRecommendationStep2Service } from '../../service/OringRecommendationStep2Service';
import {AfterViewInit, Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import { InputLimitationService } from '../../service/InputLimitationService';
import { HomeComponent } from '../home/home.component';
import { GrooveRecommendationStep2Service } from '../../service/GrooveRecommendationStep2Service';
import { NgForm } from '@angular/forms';
import { FormService } from '../../service/FormService';
import { DataToSaveService } from '../../service/data-to-save.service';
import { ImportService } from '../../service/import.service';
import { TrackingService } from '../../service/tracking.service';
import { Router, NavigationStart } from '@angular/router';
import {RecommendationType} from "../header/header.component";
import {GrooveRecommendationComponent} from "../groove-recommendation/groove-recommendation.component";


enum grooveType {
  Rectangular,
  Dovetail,
  Halfdovetail
}

@Component({
  selector: 'app-oring-recommendation',
  templateUrl: './oring-recommendation.component.html',
  providers: [OringRecommendationService, OringRecommendationStep2Service, InputLimitationService,
              GrooveRecommendationStep2Service, FormService],
  styleUrls: ['./oring-recommendation.component.css']
})
export class OringRecommendationComponent implements OnInit {
  oringRecommendationList: Array<OringRecommendation>;
  oringRecommendationListJis;
  inputlimits;
  groveItems;
  groveRecommendation = {
    angle: '',
    gap: '',
    operatingTemp: '',
    glandDepth: '',
    glandDepthTol: '',
    glandOpening: '',
    glandOpeningTol: '',
    grooveDiameter: '',
    grooveDiameterTol: '',
    topRadius: '',
    bottomRadius: ''
};

  @Input() temperatureUnit: string;
  @Input() measurementUnit: string;
  @Output() groveRecommendationEmiter = new EventEmitter();
  @Output() grooveTypeEmitter = new EventEmitter();
  @ViewChild('oringForm') form: NgForm;
  grooveType = 0;
  oringRecommendationStep2List;
  oringRecommendationJisStep2List;
  grooveItemData;
  imageSrc: string;
  grooveTypeClass: string;
  grooveRecommendationStep2Data;
  grooveRecommendationJisStep2Data;
  grooveRecommendationStep2SelectedAS;
  recommendationData;
  groveRecommendationData;
  clickInterval;
  stepSize = 0.01;
  private realOperatingTempValue;
  oringRecErrorMsg;
  showErrorMsg = true;
  private inputLimitationList;
  parentComponent: HomeComponent;
  imageLabels;
  vacuumSurfaceLevel = {
    VacuumLevel: 1e-8,
    SurfaceFinish: 16
  };
  static GroveRecommendationType = 'as';

  constructor (private oringRecommendationService: OringRecommendationService,
               private oringRecommendationStep2Service: OringRecommendationStep2Service,
               private inputLimitationService: InputLimitationService,
               private inj: Injector, private importService: ImportService,
               private grooveRecommendationStep2Service: GrooveRecommendationStep2Service,
               private dataToSaveService: DataToSaveService, private trackingService: TrackingService,
               private formService: FormService, private router: Router) {
    this.parentComponent = this.inj.get(HomeComponent);
    this.setLabelDefaultValue();
    this.getGrooveLimitations(this.measurementUnit);
  }

  ngOnInit () {
    this.router.events
      .filter(event => event instanceof NavigationStart)
      .subscribe(() => {
        if (this.router.url === '/home' ) {
          this.dataToSaveService.setGrooveInputs(this.groveRecommendation);
          this.dataToSaveService.setActiveSections(this.parentComponent.recommendations);
          this.dataToSaveService.setGrooveType(this.grooveType);
          this.dataToSaveService.setGrooveItem(this.grooveItemData);
          this.dataToSaveService.setGrooveItems(this.groveItems);
          this.dataToSaveService.setAsCode(this.grooveRecommendationStep2SelectedAS);
        }
      });
    this.getSavedData();
    this.importService.getImportEmitter().subscribe((importResults) => {
      const recommendationType = importResults[6][1];
      this.getImportedData(importResults[1], recommendationType);
    });
  }

  estimateRingSize() {
    let filterData;
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    if (this.grooveType >= 0) {
      filterData = this.oringRecommendationList.filter( item => {
        return item.GrooveType === grooveType[this.grooveType] &&
          this.issetInRange(item['LglandDepthMin' + unitSystem], item['LglandDepthMax' + unitSystem], +this.groveRecommendation.glandDepth) &&
          this.issetInRange(item['GglandWidthMin' + unitSystem], item['GglandWidthMax' + unitSystem], +this.groveRecommendation.glandOpening) &&
          this.issetInRange(item['R1Min' + unitSystem], item['R1Max' + unitSystem], +this.groveRecommendation.bottomRadius) &&
          this.issetInRange(item['R2Min' + unitSystem], item['R2Max' + unitSystem], +this.groveRecommendation.topRadius);
      });
      if(!filterData.length) {
        filterData = this.oringRecommendationListJis.filter( item => {
          return item.GrooveType === grooveType[this.grooveType] &&
            this.issetInRange(item['LglandDepthMin' + unitSystem], item['LglandDepthMax' + unitSystem], +this.groveRecommendation.glandDepth) &&
            this.issetInRange(item['GglandWidthMin' + unitSystem], item['GglandWidthMax' + unitSystem], +this.groveRecommendation.glandOpening) &&
            this.issetInRange(item['R1Min' + unitSystem], item['R1Max' + unitSystem], +this.groveRecommendation.bottomRadius) &&
            this.issetInRange(item['R2Min' + unitSystem], item['R2Max' + unitSystem], +this.groveRecommendation.topRadius);
        });
        if(filterData.length) {
          OringRecommendationComponent.GroveRecommendationType = 'jis'
          GrooveRecommendationComponent.GroveRecommendationType = 'jis'
        }
      }
    }
    this.formService.setTouched(this.form);
    this.checkForm(this.form);
    this.formService.setFocus('oringInputs');
    if (!filterData[0]) {
      if (HomeComponent.isOringFormValid) {
        this.oringRecErrorMsg = 'This groove may require a custom size O-ring for better sealing result. Please contact ASNA application Engineer for more detail';
      }
      return console.error('invalid data');
    }
    if(RecommendationType[this.parentComponent.recommendationType] !== 'design_validation') {
      this.dataToSaveService.clearedData = false;
    }
    this.oringRecErrorMsg = false;
    const ASStandardNo = filterData[0]['ASStandardNo'];
    const groveRecommendationData = this.getValidASStandardNo(ASStandardNo);
    this.groveRecommendationData = groveRecommendationData;
    if (groveRecommendationData) {
      this.recommendationData = {
        groveRecommendation: this.groveRecommendation,
        groveRecommendationData: groveRecommendationData,
        grooveType: this.grooveType,
        units: this.measurementUnit
      };
      this.groveRecommendationEmiter.emit(this.recommendationData);
      this.parentComponent.recommendations.activateGroove = true;
      this.parentComponent.recommendations.activateDesign = true;
      this.parentComponent.recommendations.activateOring = true;
    }
    this.parentComponent.oringEstimated = true;
    this.trackingService.oringEstimated(UnitSystem.getTypeByUnit(this.measurementUnit));
  }

  getData(dontClear?: boolean) {
    this.oringRecommendationService.getOringRecommendation().subscribe(res => {
      this.oringRecommendationList = res;
    });
    this.oringRecommendationService.getOringRecommendationJis().subscribe(res => {
      this.oringRecommendationListJis = res;
      // console.log('oringRecommendationListJis', this.oringRecommendationListJis);
    });
    this.grooveRecommendationStep2Service.getGrooveRecommendationJis().subscribe(res => {
      this.grooveRecommendationJisStep2Data = res;
    });
    this.oringRecommendationStep2Service.getGrooveRecommendation().subscribe(res => {
      this.oringRecommendationStep2List = res;
      // console.log(res)
    });
    this.oringRecommendationStep2Service.getGrooveRecommendationJis().subscribe(res => {
      this.oringRecommendationJisStep2List = res;
      // console.log('this.oringRecommendationJisStep2List', this.oringRecommendationJisStep2List);
    });
    this.inputLimitationService.getGrooveLimitations().subscribe(res => {
      this.inputLimitationList = res;
      this.getImputLimits(dontClear);
    });
  }

  issetInRange (min: number, max: number, value): boolean {
    return value >= min && value <= max;
  }

  private getValidASStandardNo (ASStandardNo: string) {
    const data = ASStandardNo.split('-');
    let min;
    let max;
    if(OringRecommendationComponent.GroveRecommendationType === 'as') {
      min = +data[0];
      max = +data[1];
    }else {
      const jisType = ASStandardNo[0];
      min = +String(data[0]).replace(jisType, '');
      max = +String(data[1]).replace(jisType, '');
    }
    const validASStandardNo = this.getASStandardNoByRange(min, max, ASStandardNo);
    return this.getOringByGrooveDiameter(validASStandardNo);
  }

  private getASStandardNoByRange(min: number, max: number, ASStandardNo) {
    if(OringRecommendationComponent.GroveRecommendationType === 'as') {
      return this.oringRecommendationStep2List.filter(item => {
        const as = Math.abs(+item.AS);
        return as >= min && as <= max;
      });
    }else {
      const jisType = ASStandardNo[0];
      return this.oringRecommendationJisStep2List.filter(item => {
        const value = +String(item.AS).replace(jisType, '');//Math.abs(+item.AS);
        return item.AS[0] === jisType && value >= min && value <= max;
      });
    }
  }

  private getOringByGrooveDiameter(validASStandardNo: Array<any>) {
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    let prefix = '';
    if (grooveType[this.grooveType] === grooveType[0]) {
      prefix = grooveType[0];
    }
    const data = validASStandardNo.filter(item => {
       return this.groveRecommendation.grooveDiameter >= item[prefix + 'DectectionlowerRange' + unitSystem] &&
         this.groveRecommendation.grooveDiameter <= item[prefix + 'DectectionUpperRange' + unitSystem];
    });
    if (!data.length) {
      this.oringRecErrorMsg = 'This groove may require a custom size O-ring for better sealing result. Please contact ASNA application Engineer for more detail';
      console.error('invalid data !!!');
      return false;
    }
    this.oringRecErrorMsg = false;
    if (data.length === 1) {
      return data[0];
    }else {
      let minAsData = data[0];
      for (const item of data){
        if (Math.abs(+item.AS) < Math.abs(+minAsData.AS)) {
          minAsData = item;
        }
      }
      return minAsData;
    }
  }

  getGrooveData() {
    this.dataToSaveService.setGrooveType(this.grooveType);
    this.getGrooveLimitations(this.measurementUnit, true);
    if (!this.grooveItemData) {
      this.setLabelDefaultValue();
      HomeComponent.isOringFormValid = false;
    }
  }

  initImportedData() {
    this.parentComponent.headerComp.data = {};
    this.parentComponent.headerComp.data.grooveData = this.groveRecommendation;
    this.parentComponent.headerComp.data.oringData = this.parentComponent.grooveComp.selectedASStandardOringSize;
  }

  getGrooveLimitations(measurementUnit: any, OperatingTempNotCalculate?) {
    if (measurementUnit) {
      this.measurementUnit = measurementUnit;
    }
    let groveType = this.grooveType;
    if(this.dataToSaveService.getGrooveType()) {
      groveType = this.dataToSaveService.getGrooveType()
    }
    this.changeImageSrc(grooveType[groveType]);
    this.grooveTypeClass = grooveType[groveType].toLowerCase();
    if (this.form) {
      this.formService.setUntouched(this.form);
    }
    if (this.grooveItemData) {
      return this.setGroveData();
    }
    this.getImputLimits();
    if (this.recommendationData) {
      this.grooveTypeEmitter.emit({
        groveRecommendation: this.groveRecommendation,
        groveRecommendationData: this.groveRecommendationData,
        grooveType: this.grooveType,
        units: this.measurementUnit
      });
    }
  }

  changeImageSrc(groovetype: string): void {
    this.imageSrc = `./assets/img/${groovetype.toLowerCase()}.svg`;
  }

  getImputLimits(dontChange?: boolean) {
    if (this.inputLimitationList) {
      this.inputlimits = this.inputLimitationList.find(item => {
        return grooveType[this.grooveType].toLowerCase() === item.grooveType.toLowerCase() &&
          UnitSystem.getTypeByUnit(this.measurementUnit) === item.unit;
      });
      if (!dontChange) {
        this.setgroveRecommendationData();
      }
    }
  }

  setgroveRecommendationData() {
    this.groveRecommendation = {
      angle: this.inputlimits.angle.default,
      gap: this.fixedZeroValue(this.inputlimits.gap.default),
      operatingTemp: this.inputlimits.operatingTemp.default,
      glandDepth: this.fixedZeroValue(this.inputlimits.glandDepth.default),
      glandDepthTol: this.fixedZeroValue(this.inputlimits.glandDepthTol.default),
      glandOpening: this.fixedZeroValue(this.inputlimits.glandOpening.default),
      glandOpeningTol: this.fixedZeroValue(this.inputlimits.glandOpeningTol.default),
      grooveDiameter: this.fixedZeroValue(this.inputlimits.grooveDiameter.default),
      grooveDiameterTol: this.fixedZeroValue(this.inputlimits.grooveDiameterTol.default),
      topRadius: this.fixedZeroValue(this.inputlimits.topRadius.default),
      bottomRadius: this.fixedZeroValue(this.inputlimits.bottomRadius.default)
    };
  }

  fixedZeroValue(value) {
    if (value == 0) {
      return (+value).toFixed(this.getFixedCount());
    }
    return value;
  }

  getGrooveRecommendationData(grooveData) {
    const data = grooveData.data;
    if (data.length) {
      this.groveItems = data;
      this.grooveRecommendationStep2SelectedAS = grooveData.selectedAS;
      return this.setGroveData();
    }
    console.error('invalid getGrooveRecommendationData', data);
    return;
  }

  setGroveData() {
    if (this.grooveRecommendationStep2SelectedAS) {
      this.getDiameterData();
    }
    this.grooveItemData = this.groveItems.find(item => {
      return item.GrooveType === grooveType[this.grooveType];
    });
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    this.groveRecommendation.angle = '' + parseInt(this.grooveItemData['Angle']);
    this.groveRecommendation.glandDepth = this.grooveItemData['LglandDepth' + unitSystem].toFixed(this.getFixedCount());
    this.groveRecommendation.glandOpening = this.grooveItemData['GglandWidth' + unitSystem].toFixed(this.getFixedCount());
    this.groveRecommendation.topRadius = this.grooveItemData['R2' + unitSystem].toFixed(this.getFixedCount());
    this.groveRecommendation.bottomRadius = this.grooveItemData['R1' + unitSystem].toFixed(this.getFixedCount());
    this.updateLabels();
    this.parentComponent.headerComp.data = {};
    this.parentComponent.headerComp.data.grooveData = this.groveRecommendation;
    this.parentComponent.headerComp.data.oringData = this.parentComponent.grooveComp.selectedASStandardOringSize;
  }

  getDiameterData() {
    if (this.grooveRecommendationStep2Data) {
      this.getDiameterByAs();
    }else {
      this.grooveRecommendationStep2Service.getGrooveRecommendation().subscribe(res => {
        this.grooveRecommendationStep2Data = res;
        this.getDiameterByAs();
      });
    }
  }

  getDiameterByAs() {
    const selectedAS = this.grooveRecommendationStep2SelectedAS;
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    let grooveRecommendationStep2Data = this.grooveRecommendationStep2Data;
    if(GrooveRecommendationComponent.GroveRecommendationType !== 'as') {
      grooveRecommendationStep2Data = this.grooveRecommendationJisStep2Data;
    }
    const item = grooveRecommendationStep2Data.find(item => {
      return item['AS'] == selectedAS;
    });
    if (grooveType[this.grooveType] === 'Rectangular') {
      this.groveRecommendation.grooveDiameter = item['Rectangular_groove_ID_' + unitSystem].toFixed(this.getFixedCount());
    } else {
      this.groveRecommendation.grooveDiameter = item['Halfdovetail_Dovetail_groove_ID_' + unitSystem].toFixed(this.getFixedCount());
    }
    this.changeLabel('d', this.groveRecommendation.grooveDiameter);
  }

  changeInputValue (e, input, label = null) {
    if (!Number(input.value) && Number(input.value) !== 0) return;
    const model = e.model;
    let currentStep;
    let fixedCount = this.getFixedCount();
    if (e.model === 'angle' || e.model === 'operatingTemp') {
      currentStep = 1;
      fixedCount = 0;
    } else {
      currentStep = this.getStepSize(this.measurementUnit);
    }
    let stopIncrease = false;
    let stopDecrement = false;
    this.clickInterval = setInterval(() => {
      if (e.operation === 'increment' && !stopIncrease) {
        stopDecrement = false;
        if (this.groveRecommendation[model] >= this.setRange(e.model, 'max')) {
          stopIncrease = true;
          return;
        }
        const n = +this.groveRecommendation[model] + currentStep;
        this.groveRecommendation[model] = n.toFixed(fixedCount);
      } else if (e.operation === 'decrement' && !stopDecrement) {
        stopIncrease = false;
        if (this.groveRecommendation[model] <= this.setRange(e.model, 'min')) {
          stopDecrement = true;
          return;
        }
        const n = +this.groveRecommendation[model] - currentStep;
        this.groveRecommendation[model] = n.toFixed(fixedCount);
      }
      if (label) {
        this.changeLabel(label, this.groveRecommendation[model]);
      }
      input.focus();
    }, 80);
  }

  cancelEvent (e) {
    clearInterval(this.clickInterval);
    this.clickInterval = false;
  }

  checkForm (oringForm: NgForm) {
    this.getImputLimits(true);
    this.showErrorMsg = true;
    for (const input in oringForm.value) {
      if (input === 'glandDepthTol' || input === 'glandOpeningTol' || input === 'grooveDiameterTol') {
        continue;
      } else if (input === 'gap') {
        if (oringForm.value[input] > this.setRange(input, 'max') || oringForm.value[input] < this.setRange(input, 'min')) {
          oringForm.controls[input].setErrors({'rangeError': true});
        }
        continue;
      } else if (input === 'angle' || input === 'operatingTemp') {
        if (oringForm.value[input] > this.setRange(input, 'max') || oringForm.value[input] < this.setRange(input, 'min')) {
          oringForm.controls[input].setErrors({'rangeError': true});
        }
      } else if (oringForm.value[input] > this.setRange(input, 'max') || oringForm.value[input] <= this.setRange(input, 'min')) {
        oringForm.controls[input].setErrors({'rangeError': true});
      }
    }
    if (oringForm.valid && oringForm.touched) {
      HomeComponent.isOringFormValid = true;
    } else {
      HomeComponent.isOringFormValid = false;
    }
  }

  setRange (inputName: string, type: string) {
    if (this.inputlimits && this.inputlimits[inputName]) {
      if (this.form.controls['glandDepth'] && inputName === 'gap' && type === 'max') {
        return this.getGapMax();
      }

      return this.inputlimits[inputName][type];
    }
    return;
  }

  getGapMax () {
    return (this.form.controls['glandDepth'].value * this.inputlimits.gap.max).toFixed(this.measurementUnit === 'mm' ? 2 : 3);
  }

  getStepSize (unitSystem: string) {
    return unitSystem === 'mm' ? this.stepSize = 0.01 : this.stepSize = 0.001;
  }

  updateRealOperatingTempValue (input, e?) {
    if (e) {
      this.changeInputValue(e, input);
      const interval = setInterval(() => {
        if (!this.clickInterval) {
          clearInterval(interval);
        }
        this.realOperatingTempValue = this.groveRecommendation.operatingTemp;
      }, 80);
    } else {
      this.realOperatingTempValue = this.groveRecommendation.operatingTemp;
    }
  }

  getErrorMsg(element, inputName) {
      if (inputName === 'gap' && this.form.controls['glandDepth'] && (this.form.controls['glandDepth'].value < this.getStepSize(this.measurementUnit))) {
        return `Please enter a valid Gland Depth first.`;
      }
      if (this.showErrorMsg && element.errors && element.touched) {
        if (inputName === 'angle') {
          return `Invalid input. Typical value range: ${this.setRange(inputName, 'min')} - ${this.setRange(inputName, 'max')} degree`;
        } else if (inputName === 'operatingTemp') {
          return `Invalid input. Typical value range: ${this.setRange(inputName, 'min')} - ${this.setRange(inputName, 'max')} ${this.temperatureUnit}`;
        } else if (inputName === 'gap') {
          return `The gap may be too large for this gland. Please check again.`;
        }
        return `Invalid input. Typical value range: ${this.setRange(inputName, 'min')} - ${this.setRange(inputName, 'max')} ${this.measurementUnit}`;
      }
      return false;
  }

  getVacumLavelErrorMsg(vacumLavel) {
    if(this.showErrorMsg && vacumLavel.touched && vacumLavel.errors) {
      return 'Invalid input. Typical value range: 0 - 760 Torr';
    }
    return false;
  }

  getErrorMsgNotRequaredElem(element, inputName) {
    if (this.showErrorMsg && element.errors && element.touched) {
      if (element.value && element.errors.rangeError) {
        return `Invalid input. Typical value range: ${this.setRange(inputName, 'min')} - ${this.setRange(inputName, 'max')} ${this.measurementUnit}`;
      }
    }
  }

  clearOringData() {
    this.deleteErrorMsg();
    this.setLabelDefaultValue();
    this.formService.setUntouched(this.form);
    this.parentComponent.oringEstimated = false;
    HomeComponent.isOringFormValid = false;
  }

  deleteErrorMsg() {
    this.showErrorMsg = false;
    this.oringRecErrorMsg = false;
  }

  getFixedCount() {
    const unitSystem = UnitSystem.getTypeByUnit(this.measurementUnit);
    if (unitSystem === 'M') {
      return 2;
    }
    return 3; // when English
  }

  changeLabel(key, value) {
    this.imageLabels[key] = value;
  }

  setLabelDefaultValue() {
    this.imageLabels = {
      s: 'S',
      w: 'W',
      r1: 'R1',
      r2: 'R2',
      l: 'L',
      d: 'D',
    };
  }

  updateLabels () {
    for (const item in this.groveRecommendation) {
      let bool = item !== 'glandDepthTol' && item !== 'glandOpeningTol' && item !== 'grooveDiameterTol';
      if (bool && item !== 'angle' && item !== 'operatingTemp' &&  +this.groveRecommendation[item] !== 0
        && this.groveRecommendation[item] !== '' && !isNaN(this.groveRecommendation[item])) {
        this.imageLabels = {
          s: this.groveRecommendation.gap,
          w: this.groveRecommendation.glandOpening,
          r1: this.groveRecommendation.bottomRadius,
          r2: this.groveRecommendation.topRadius,
          l: this.groveRecommendation.glandDepth,
          d: this.groveRecommendation.grooveDiameter,
        };
        return;
      }
    }
    this.setLabelDefaultValue();
  }

  getSavedData(): void {
    const paths = this.dataToSaveService.getPaths();
    const activeSections = this.dataToSaveService.getActiveSections();
    this.updateLabels();
    if (paths.length > 0 && paths[paths.length - 1] === 'saved-files' && activeSections && activeSections.activateOring) {
      this.getData(true);
      this.grooveType = this.dataToSaveService.getGrooveType();
      this.groveRecommendation = this.dataToSaveService.getGrooveInputs();
      this.parentComponent.recommendations.activateOring = true;
      this.grooveItemData = this.dataToSaveService.getGrooveItem();
      this.groveItems = this.dataToSaveService.getGrooveItems();
      this.grooveRecommendationStep2SelectedAS = this.dataToSaveService.getAsCode();
      this.updateLabels();
    } else {
      this.getData(false);
    }
  }

  getImportedData(importedData: string[], recommendationType: string): void {
    if (importedData[0].indexOf(' ') > -1) {
      let key = importedData[0].trim().replace(' ', '').replace('D', 'd');
      if(key === 'dovetail') {
        key = 'Dovetail';
      }
      this.grooveType = +grooveType[key];
    } else {
      this.grooveType = +grooveType[importedData[0]];
    }
    this.grooveTypeClass = grooveType[this.grooveType].toLowerCase();
    this.groveRecommendation = {
      angle: importedData[1],
      operatingTemp: importedData[2],
      glandDepth: importedData[3],
      glandDepthTol: importedData[4],
      glandOpening: importedData[5],
      glandOpeningTol: importedData[6],
      grooveDiameter: importedData[7],
      grooveDiameterTol: importedData[8],
      topRadius: importedData[9],
      bottomRadius: importedData[10],
      gap: '0'
    };
    this.changeImageSrc(grooveType[this.grooveType]);
    this.updateLabels();
    if(recommendationType === 'oring_recommendation') {
      this.parentComponent.recommendationType = 0;
    }else if(recommendationType === 'groove_recommendation') {
      this.parentComponent.recommendationType = 1;
    }else if(recommendationType === 'design_validation') {
      this.parentComponent.recommendationType = 2;
    }
  }

  changeVacumLevel(vacumLavel) {
    const value = this.vacuumSurfaceLevel.VacuumLevel;
    if(value >= 0 && value < 1e-10) {
      this.vacuumSurfaceLevel.SurfaceFinish = 8;
    }else if(value >= 1e-10 && value < 0.1) {
      this.vacuumSurfaceLevel.SurfaceFinish = 16;
    }else if(value >= 0.1 && value <= 760) {
      this.vacuumSurfaceLevel.SurfaceFinish = 32;
    }
  }
}



// WEBPACK FOOTER //
// /var/www/asna/front-end/public_html/src/app/components/oring-recommendation/oring-recommendation.component.ts